import { render } from "./ai-form-text-box-readonly.vue?vue&type=template&id=1f8d703e&scoped=true"
import script from "./ai-form-text-box-readonly.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-form-text-box-readonly.vue?vue&type=script&setup=true&lang=js"

import "./ai-form-text-box-readonly.vue?vue&type=style&index=0&id=1f8d703e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8d703e"],['__file',"src/components/card-component/ai-form-text-box-readonly.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f8d703e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f8d703e', __exports__)) {
    api.reload('1f8d703e', __exports__)
  }
  
  module.hot.accept("./ai-form-text-box-readonly.vue?vue&type=template&id=1f8d703e&scoped=true", () => {
    api.rerender('1f8d703e', render)
  })

}


export default __exports__